import { render, staticRenderFns } from "./IndicationResult.vue?vue&type=template&id=1ef541ae&scoped=true"
import script from "./IndicationResult.vue?vue&type=script&lang=js"
export * from "./IndicationResult.vue?vue&type=script&lang=js"
import style0 from "./IndicationResult.vue?vue&type=style&index=0&id=1ef541ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef541ae",
  null
  
)

export default component.exports